export function createDeferredPromise() {
    let resolveFn;
    let rejectFn;
    const promise = new Promise((resolve, reject)=>{
        resolveFn = resolve;
        rejectFn = reject;
    });
    promise.pending = true;
    promise.resolve = (value)=>{
        promise.pending = false;
        resolveFn(value);
    };
    promise.reject = (reason)=>{
        promise.pending = false;
        rejectFn(reason);
    };
    return promise;
}
